import React, { useEffect, useState } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  FormGroup,
  Input,
  Row,
  Spinner,
} from "reactstrap";
import swal from "sweetalert";
import { useDispatch, useSelector } from "react-redux";

import { updateProfile } from "actions/AuthAction";

import axios from "axios";
import { GET_TOKEN, GET_INSTANSI, parseDateSafe } from "utils";
import { getUserDHO } from "actions/GetUserAction";
import { API_TIMEOUT } from "utils";
import { refreshToken } from "utils/function";
// Removed FIREBASE import - not needed for admin email update

export default function EditASNUser() {
  const { id } = useParams();
  const idKu = id.split(",");
  const asal = idKu[1];

  const dispatch = useDispatch();

  const { getUserError, getUserResult, getUserLoading } = useSelector(
    (state) => state.GetUserReducer
  );

  const { updateLoading, updateResult } = useSelector(
    (state) => state.AuthReducer
  );

  const history = useHistory();

  const [instansi, setInstansi] = useState("");
  const [nama, setNama] = useState("");
  const [waktuMasuk, setWaktuMasuk] = useState("");
  const [dho, setDho] = useState("");

  const [waktuPulang, setWaktuPulang] = useState("");
  const [status, setStatus] = useState("");
  const [avatar, setAvatar] = useState("");
  const [saveLoading, setSaveLoading] = useState(false);
  const [listInstansi, setListInstansi] = useState([]);

  const [alamat, setAlamat] = useState("");
  const [desa, setDesa] = useState("");
  const [domisili, setDomisili] = useState("");
  const [email, setEmail] = useState("");
  const [newEmail, setNewEmail] = useState(""); // State untuk email baru
  const [fcmToken, setFcmToken] = useState("");
  const [gender, setGender] = useState("");
  const [kecamatan, setKecamatan] = useState("");
  const [namaPengguna, setNamaPengguna] = useState("");
  const [uid, setUid] = useState("");

  const [nik, setNik] = useState("");

  const [nip, setNip] = useState("");
  const [nohp, setNohp] = useState("");
  const [pangkat, setPangkat] = useState("");
  const [statusRegister, setStatusRegister] = useState("");
  const [token, setToken] = useState("");
  const [unitKerja, setUnitKerja] = useState("");
  const [date, setDate] = useState("");
  const [dob, setDob] = useState("");
  const [provinsi, setProvinsi] = useState("");
  const [kota, setKota] = useState("");
  const [loadingEdit, setLoadingEdit] = useState(false);
  const [statuspegawai, setStatusPegawai] = useState("");
  const [statusAktifitas, setStatusAktifitas] = useState("");

  const [statusUser, setStatusUser] = useState("");

  const [edit, setEdit] = useState(false);
  const [emailUpdateLoading, setEmailUpdateLoading] = useState(false); // Loading state untuk update email

  // auth

  const [accessToken, setAccessToken] = useState("");

  useEffect(() => {
    refreshToken(setAccessToken, history);
  }, []);

  // Function untuk admin mengubah email user lain
  // Admin dapat mengubah email user tanpa perlu re-authentication
  // karena admin memiliki hak akses untuk mengubah data user lain
  const updateUserEmail = async () => {
    if (!newEmail || newEmail === email) {
      swal(
        "Error",
        "Email baru tidak boleh kosong atau sama dengan email lama",
        "error"
      );
      return;
    }

    // Validasi format email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(newEmail)) {
      swal("Error", "Format email tidak valid", "error");
      return;
    }

    // Konfirmasi admin
    const result = await swal({
      title: "Konfirmasi Update Email",
      text: `Anda akan mengubah email user dari "${email}" menjadi "${newEmail}". Lanjutkan?`,
      icon: "warning",
      buttons: {
        cancel: "Batal",
        confirm: "Ya, Update Email",
      },
      dangerMode: true,
    });

    if (!result) {
      return;
    }

    setEmailUpdateLoading(true);
    swal("Info", "Proses update email sedang berjalan...", "info");

    try {
      // Validasi data sebelum API call
      if (!uid) {
        setEmailUpdateLoading(false);
        swal("Error", "UID user tidak ditemukan", "error");
        return;
      }

      if (!newEmail) {
        setEmailUpdateLoading(false);
        swal("Error", "Email tidak valid", "error");
        return;
      }
      //http://localhost:3001/api/admin/update/user-email/${uid}
      // Panggil API backend untuk update email dengan Firebase Admin SDK
      const response = await axios({
        method: "patch",
        url: `https://smartdh.rotendaokab.go.id/api/firebase/update/user-email/${uid}`,
        timeout: 10000, // 10 detik timeout
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          oldEmail: email,
          newEmail: newEmail,
          uid: uid,
        },
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.status === 200 && response.data.success) {
        // Update email di database lokal juga
        const updatedData = {
          uid: uid,
          email: newEmail,
          // Data lain tetap sama
          nama: nama,
          alamat: alamat,
          nohp: nohp,
          kecamatan: kecamatan,
          desa: desa,
          pangkat: pangkat,
          unitKerja: instansi,
          nip: nip,
          status: status,
          avatar: avatar ? avatar : "",
          domisili: domisili,
          statusRegister: statusRegister,
          provinsi: provinsi,
          kota: kota,
          dob: parseDateSafe(dob),
          date: parseDateSafe(date),
          gender: gender,
          fcmToken: fcmToken ? fcmToken : "",
          token: token ? token : "",
          nik: nik,
          namaPengguna: namaPengguna,
          dho: dho,
          statusDHO: statusAktifitas,
          statuspegawai: statuspegawai,
        };

        // Dispatch update profile dengan email baru
        dispatch(
          updateProfile(updatedData, () => {
            setEmailUpdateLoading(false);
            setEmail(newEmail);
            setNewEmail("");
            swal("Success", "Email user berhasil diubah oleh admin", "success");
          })
        );
      } else {
        throw new Error("Backend API returned non-success response");
      }
    } catch (error) {
      setEmailUpdateLoading(false);
      console.error("Error updating email:", error);
      console.error("Error details:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        statusText: error.response?.statusText,
        code: error.code,
      });

      let errorMessage = "Terjadi kesalahan saat mengubah email user";

      if (error.code === "ECONNREFUSED") {
        errorMessage =
          "Tidak dapat terhubung ke backend. Pastikan backend berjalan di port 3001.";
      } else if (error.code === "ENOTFOUND") {
        errorMessage = "URL backend tidak ditemukan.";
      } else if (error.code === "ETIMEDOUT") {
        errorMessage = "Request timeout. Coba lagi.";
      } else if (error.response) {
        // Error dari backend API
        const backendError = error.response.data;

        if (backendError.message) {
          errorMessage = backendError.message;
        } else if (error.response.status === 400) {
          errorMessage = "Data yang dikirim tidak valid";
        } else if (error.response.status === 401) {
          errorMessage = "Tidak memiliki akses admin untuk mengubah email user";
        } else if (error.response.status === 403) {
          errorMessage = "Tidak memiliki akses admin";
        } else if (error.response.status === 404) {
          errorMessage = "User tidak ditemukan";
        } else if (error.response.status === 409) {
          errorMessage = "Email sudah digunakan oleh user lain";
        } else if (error.response.status === 429) {
          errorMessage =
            "Terlalu banyak request update email. Silakan coba lagi dalam 15 menit.";
        } else if (error.response.status === 500) {
          errorMessage = "Terjadi kesalahan di server";
        }
      } else if (error.code === "auth/email-already-in-use") {
        errorMessage = "Email sudah digunakan oleh user lain";
      } else if (error.code === "auth/invalid-email") {
        errorMessage = "Format email tidak valid";
      } else if (error.code === "auth/user-not-found") {
        errorMessage = "User tidak ditemukan";
      } else {
        errorMessage = `Error: ${error.message || error}`;
      }

      swal("Error", errorMessage, "error");
    }
  };

  //auth

  const getListInstansi = async () => {
    var data1 = [];

    try {
      const response = await axios.get(GET_INSTANSI);
      data1 = response.data.data;

      if (data1.length > 0) {
        const dataInstansi = data1.map((item) => {
          return item.unitKerja;
        });
        setListInstansi(dataInstansi);
      } else {
        setListInstansi([]);
      }
      // berita.gambarKu = berita.gambar.split(',');
      // berita.isiKu = berita.isi.split('##');
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getListInstansi();
    getStatusUser();
    var today = new Date();
    var time =
      today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    setWaktuMasuk(time);
  }, []);

  const getStatusUser = async () => {
    const user = JSON.parse(window.localStorage.getItem("user"));
    setStatusUser(user.status);
  };

  useEffect(() => {
    if (idKu[0]) {
      dispatch(getUserDHO(idKu[0]));
    }
  }, [id]);
  useEffect(() => {
    if (getUserResult) {
      setNama(getUserResult.nama);

      setAvatar(getUserResult.avatar ? getUserResult.avatar : "");
      setAlamat(getUserResult.alamat);

      setDomisili(getUserResult.domisili);
      setEmail(getUserResult.email);
      setNewEmail(getUserResult.email); // Set email baru sama dengan email lama
      setFcmToken(getUserResult.fcmToken);
      setGender(getUserResult.gender);
      setUid(getUserResult.uid);
      setDho(getUserResult.dho ? getUserResult.dho : "android");
      setStatusPegawai(
        getUserResult.statuspegawai ? getUserResult.statuspegawai : "aktif"
      );
      setStatusAktifitas(
        getUserResult.statusDHO ? getUserResult.statusDHO : "reguler"
      );

      setNamaPengguna(getUserResult.namaPengguna);
      setNik(getUserResult.nik);

      setNohp(getUserResult.nohp);

      setStatus(getUserResult.status);
      setStatusRegister(getUserResult.statusRegister);
      setToken(getUserResult.token);
      if (getUserResult.domisili == "Kabupaten Rote Ndao") {
        setDesa(getUserResult.desa);
        setKecamatan(getUserResult.kecamatan);
      } else {
        setKota(getUserResult.kota);
        setProvinsi(getUserResult.provinsi);
      }
      if (getUserResult.statusRegister == "ASN") {
        setPangkat(getUserResult.pangkat);
        setNip(getUserResult.nip);
        setInstansi(getUserResult.unitKerja);
      }
      if (getUserResult.dob) {
        var aa = getUserResult.dob.split("T");
        var bb = aa[0].split("-");

        setDob(aa[0]);
      }
      if (getUserResult.date) {
        var aa = getUserResult.date.split("T");
        var bb = aa[0].split("-");

        setDate(aa[0]);
      }
    }
  }, [getUserResult]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    swal({
      title: "Apakah anda yakin ?",
      text: "Data yang sudah diedit tidak bisa dikembalikan !",
      icon: "warning",
      buttons: ["Tidak, batalkan!", "Ya, saya yakin!"],
      dangerMode: true,
    }).then(function (isConfirm) {
      if (isConfirm) {
        updateProfil(); // <--- submit form programmatically
      } else {
        swal("Cancelled", "data profil tidak diupdate  :)", "error");
      }
    });
  };

  const updateProfil = () => {
    setSaveLoading(true);

    // console.log(avatar);
    // this.props.dispatch(updateJersey(this.state));

    const data = {
      uid: uid,
      nama: nama,
      alamat: alamat,
      nohp: nohp,
      kecamatan: kecamatan,
      desa: desa,
      email: email,
      pangkat: pangkat,
      unitKerja: instansi,
      nip: nip,
      status: status,
      avatar: avatar ? avatar : "",
      domisili: domisili,
      statusRegister: statusRegister,
      provinsi: provinsi,
      kota: kota,
      dob: parseDateSafe(dob),
      date: parseDateSafe(date),
      gender: gender,
      fcmToken: fcmToken ? fcmToken : "",
      token: token ? token : "",
      nik: nik,
      namaPengguna: namaPengguna,
      dho: dho,
      statusDHO: statusAktifitas,
      statuspegawai: statuspegawai,
    };

    // console.log(data);

    dispatch(
      updateProfile(data, () => {
        setSaveLoading(false);
      })
    );
  };

  return (
    <div className="content">
      <Row>
        <Col>
          <Link
            to={asal ? "/admin/all" : "/admin/listakun"}
            className="btn btn-primary"
          >
            Kembali
          </Link>
        </Col>
      </Row>

      <Row>
        <Col>
          <Card>
            <CardHeader tag="h4">Data Smart User</CardHeader>
            <CardBody>
              <form onSubmit={(event) => handleSubmit(event)}>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <label>Nama</label>
                      <Input
                        type="text"
                        value={nama}
                        name="nama"
                        onChange={(event) => setNama(event.target.value)}
                      />
                    </FormGroup>

                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <label>Nama pengguna</label>
                          <Input
                            type="text"
                            name="jenis"
                            value={namaPengguna}
                            onChange={(event) =>
                              setNamaPengguna(event.target.value)
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <label>NIK</label>
                          <Input
                            type="text"
                            name="harga"
                            value={nik}
                            onChange={(event) => setNik(event.target.value)}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <FormGroup>
                      <label>Domisili</label>
                      <Input
                        type="text"
                        value={domisili}
                        name="nama"
                        onChange={(event) => setDomisili(event.target.value)}
                      />
                    </FormGroup>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <label>Alamat</label>
                          <Input
                            type="text"
                            name="jenis"
                            value={alamat}
                            onChange={(event) => setAlamat(event.target.value)}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <label>
                            {domisili == "Kabupaten Rote Ndao"
                              ? "Desa"
                              : "Kota"}
                          </label>
                          <Input
                            type="text"
                            name="harga"
                            value={desa}
                            onChange={(event) => setDesa(event.target.value)}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <label>
                            {domisili == "Kabupaten Rote Ndao"
                              ? "Kecamatan"
                              : "Provinsi"}
                          </label>
                          <Input
                            type="text"
                            name="jenis"
                            value={kecamatan}
                            onChange={(event) =>
                              setKecamatan(event.target.value)
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <label>Email Saat Ini</label>
                          <Input
                            type="text"
                            name="harga"
                            value={email}
                            disabled
                            style={{ backgroundColor: "#f8f9fa" }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    {/* Email Update Section - Admin Function */}
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <label>Email Baru (Admin Update)</label>
                          <Input
                            type="email"
                            name="newEmail"
                            value={newEmail}
                            onChange={(event) =>
                              setNewEmail(event.target.value)
                            }
                            placeholder="Masukkan email baru untuk user"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <label>&nbsp;</label>
                          <Button
                            type="button"
                            color="warning"
                            onClick={updateUserEmail}
                            disabled={
                              emailUpdateLoading ||
                              !newEmail ||
                              newEmail === email
                            }
                            style={{ width: "100%" }}
                          >
                            {emailUpdateLoading ? (
                              <>
                                <Spinner
                                  size="sm"
                                  color="light"
                                  style={{ marginRight: "8px" }}
                                />
                                Updating Email...
                              </>
                            ) : (
                              <>
                                <i className="nc-icon nc-settings-gear-65 mr-2"></i>
                                Update Email (Admin)
                              </>
                            )}
                          </Button>
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                  <Col md={6}>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <label>Perangkat DHO</label>
                          <Input
                            type="select"
                            value={dho}
                            name="jenis"
                            onChange={(event) => setDho(event.target.value)}
                          >
                            <option value={"android"} key={1}>
                              {"android"}
                            </option>
                            <option value={"iphone"} key={2}>
                              {"iphone"}
                            </option>
                            {statusUser === "super admin" && (
                              <option value={"admin"} key={3}>
                                {"admin"}
                              </option>
                            )}
                          </Input>
                        </FormGroup>
                        <FormGroup>
                          <label>Status Pegawai</label>
                          <Input
                            type="select"
                            value={statuspegawai}
                            name="jenis"
                            onChange={(event) =>
                              setStatusPegawai(event.target.value)
                            }
                          >
                            <option value={"aktif"} key={1}>
                              {"aktif"}
                            </option>
                            <option value={"pensiun"} key={2}>
                              {"pensiun"}
                            </option>
                            <option value={"meninggal"} key={3}>
                              {"meninggal"}
                            </option>
                            <option value={"pindah keluar kabupaten"} key={4}>
                              {"pindah keluar kabupaten"}
                            </option>
                            <option value={"tidak aktif"} key={5}>
                              {"tidak aktif"}
                            </option>
                          </Input>
                        </FormGroup>
                        <FormGroup>
                          <label>Jenis aktivitas kantor - status DHO</label>
                          <Input
                            type="select"
                            value={statusAktifitas}
                            name="jenis"
                            onChange={(event) =>
                              setStatusAktifitas(event.target.value)
                            }
                          >
                            <option value={"reguler"} key={1}>
                              {"reguler"}
                            </option>
                            <option value={"shift"} key={2}>
                              {"shift"}
                            </option>
                          </Input>
                        </FormGroup>
                        <FormGroup>
                          <label>Status Registrasi</label>
                          <Input
                            type="text"
                            value={statusRegister}
                            name="jenis"
                          />
                        </FormGroup>
                        {statusRegister == "ASN" && (
                          <>
                            <FormGroup>
                              <label>Perangkat Daerah</label>
                              <Input
                                type="select"
                                value={instansi}
                                name="jenis"
                                onChange={(event) =>
                                  setInstansi(event.target.value)
                                }
                              >
                                {listInstansi.map((item, index) => (
                                  <option value={item} key={index}>
                                    {item}
                                  </option>
                                ))}
                              </Input>
                            </FormGroup>
                            <FormGroup>
                              <label>Pangkat</label>
                              <Input
                                type="text"
                                value={pangkat}
                                name="jenis"
                                onChange={(event) =>
                                  setPangkat(event.target.value)
                                }
                              />
                            </FormGroup>
                            <FormGroup>
                              <label>NIP</label>
                              <Input
                                type="text"
                                value={nip}
                                name="jenis"
                                onChange={(event) => setNip(event.target.value)}
                              />
                            </FormGroup>
                            <FormGroup>
                              <label>Tanggal lahir</label>
                              <Input
                                type="date"
                                value={dob}
                                name="jenis"
                                onChange={(event) => setDob(event.target.value)}
                              />
                            </FormGroup>
                          </>
                        )}
                      </Col>
                      <Col>
                        <img
                          src={avatar}
                          alt={"avatar"}
                          style={{
                            width: 200,
                            height: 200,
                            borderRadius: 100,
                            borderWidth: 8,
                            borderColor: "red",
                          }}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>

                <Row>
                  {!edit ? (
                    <Col>
                      {saveLoading ? (
                        <Button color="primary" type="submit" disabled>
                          <Spinner size="sm" color="light" /> Updating...
                        </Button>
                      ) : (
                        <Button type="submit" color="danger" className="ml-2">
                          <i className="nc-icon nc-basket"></i> Edit
                        </Button>
                      )}
                    </Col>
                  ) : (
                    <></>
                  )}
                </Row>
              </form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
